/** @format */
// export const BASE_URL = 'http://localhost:5000/api';
export const BASE_URL = 'https://liquor-house01-054f52ad13a0.herokuapp.com/api';
export const token = localStorage.getItem('token');
